import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PlusCircleIcon from 'react-icons/lib/fa/plus-circle';

import Styles from './styles';
import Hr from '../UIKit/Hr';
import Label from '../UIKit/Label';
import Spacer from '../Spacer';
import Button from '../UIKit/Button';
import SortableList from '../SortableList';

const AppDrawer = (props) => {
  const projects = props.projects.map((item) => {
    const organization = item;
    organization.text = item.name;
    organization.id = item.key;
    organization.icon = 'icon-cube';
    return organization;
  });

  return (
    <div style={Styles.wrapper}>
      <div style={Styles.logoWrapper}>
        <img alt="" style={Styles.logo} src={require('../../assets/images/login-logo.png')} />
      </div>
      <Hr style={Styles.hr} />
      <div style={Styles.projectsWrapper}>
        <Label style={{ padding: 10 }}>
          Projects <Spacer />
          <Link to="/projects" style={{ fontSize: 12, margin: '0 10px' }}>
            View all
          </Link>
        </Label>
        <SortableList
          items={projects}
          onItemClick={props.onProjectClick}
          itemStyle={Styles.project}
          selected={0}
        />
        <Link style={{ color: 'inherit' }} to="/projects/add">
          <Button size="sm" style={Styles.addButton}>
            <PlusCircleIcon size={17} />
          </Button>
        </Link>
      </div>
      <Spacer />
    </div>
  );
};

AppDrawer.propTypes = {
  projects: PropTypes.array,
};

AppDrawer.defaultProps = {
  projects: [],
};

export default AppDrawer;



// WEBPACK FOOTER //
// ./src/components/AppDrawer/index.js